export const getHeaderIP = (selected, deductions) => {
  const { payrollTypes, jobTypeVal, payItems } = selected;
  const { additionalType, contributionType, deductionType } = deductions;

  const IndividualHdrs = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "GROSS" },
    { rowSpan: 2, label: "PERA/ADA" },
    { rowSpan: 2, label: "IN SERVICE" },
    // { rowSpan: 2, label: "# OF DAYS 1 MONTH" },
    // { rowSpan: 2, label: "HOL/ WKENDS/OFF" },
    { rowSpan: 2, label: "PRORATED RATE" },
    { rowSpan: 2, label: "PRORATED PERA" },
    // { rowSpan: 2, label: "PER DAY" },
    // { rowSpan: 2, label: "PER MINUTE" },
    // { rowSpan: 2, label: "PER DAY" },
    // { rowSpan: 2, label: "PER MINUTE" },
    { colSpan: 1, label: "DEDUCTION" },
    { colSpan: 1, label: "BASIC" },
    { colSpan: 1, label: "PERA ADA" },
    { rowSpan: 2, label: "DAYS FOR GSIS" },
    { rowSpan: 2, label: "BASIC EARNED" },
    { rowSpan: 2, label: "PERA ADA EARNED" },
    { rowSpan: 2, label: "TOTAL" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualSubHdrs = [
    // "DAYS",
    // "HALF DAYS",
    "MINS",
    // "DAYS",
    // "HALF DAYS",
    "MINS",
    // "BASIC",
    // "DAYS",
    "MINS",
    // "PERA",
    "TAX",
    ...contributionType,
  ];

  const IndividualAPInitialHdrs = [
    { rowSpan: 2, label: "#" },
    { colSpan: 1, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "Y=24/7 N=7:00-5:30" },
    { rowSpan: 2, label: "# of duty for CIA/MCIA/BINOC (Range to 15-19)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "AP RATE" },
    // { rowSpan: 2, label: "DAILY RATE" },
    // { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "OVERPAYMENT" },
    { rowSpan: 2, label: "FLAG RAISING" },
    { rowSpan: 2, label: "DAYS EARNED" },
    { rowSpan: 2, label: "NO. OF LATES INCURRED" },
    { rowSpan: 2, label: "LATES/UT DEDUCTION" },
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualAPInitialSubHdrs = ["DATE"];

  const IndividualAPLastHdrs = [
    { rowSpan: 2, label: "#" },
    { colSpan: 1, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "Y=24/7 N=7:00-5:30" },
    { rowSpan: 2, label: "# of duty for CIA/MCIA/BINOC (Range to 15-19)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "PLANTILLA ITEMS" },
    { rowSpan: 2, label: "AP RATE" },
    // { rowSpan: 2, label: "DAILY RATE" },
    // { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "OVERPAYMENT" },
    { rowSpan: 2, label: "FLAG RAISING" },
    { rowSpan: 2, label: "DAYS EARNED" },
    { rowSpan: 2, label: "NO. OF LATES INCURRED" },
    { rowSpan: 2, label: "LATES/UT DEDUCTION" },
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IndividualAPLastSubHdrs = ["DATE", ...deductionType];

  const IndividualRataHdrs = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    {
      rowSpan: 2,
      label: "REPRESENTATION ALLOWANCE/TRANSPORTATION ALLOWANCE (RATA)",
    },
    {
      rowSpan: 2,
      label: "NUMBER OF WORKDAYS OF ACTUAL WORK PERFORMANCE IN A MONTH",
    },
    { rowSpan: 2, label: "ACTUAL RATA FOR A MONTH" },
    { rowSpan: 2, label: "NET AMOUNT" },
  ];

  const IndividualRataSubHdrs = [];

  const IPSalaryDiffBasicHdrs = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "TOTAL AMT EARNED" },
    { rowSpan: 2, label: "GSIS" },
    { rowSpan: 2, label: "PHILHEALTH" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "MY DIFF" },
    { rowSpan: 2, label: "YE DIFF" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IPSalaryDiffBasicSubHdrs = [];

  const IPSalaryDiffAddHdrs = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "OLD ITEM" },
    { rowSpan: 2, label: "OLD RATE" },
    { rowSpan: 2, label: "NEW ITEM" },
    { rowSpan: 2, label: "NEW RATE" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "GSIS DIFF" },
    { rowSpan: 2, label: "PH DIFF" },
    { rowSpan: 2, label: "NET PAY" },
  ];

  const IPSalaryDiffAddSubHdrs = [];

  const IPInitialJOHdrs = [
    { rowSpan: 2, label: "#" },
    ...(payItems === "Last" ? [{ colSpan: 1, label: "PERIOD COVERED" }] : []),
    { rowSpan: 2, label: "# of duty for CIA/MCIA/BINOC (Range to 15-19)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC SALARY" },
    { rowSpan: 2, label: "NO. OF DAYS PRESENT" },
    { rowSpan: 2, label: "PRORATED RATE" },
    // { rowSpan: 2, label: "PER DAY" },
    // { rowSpan: 2, label: "PER MINUTE" },
    // { rowSpan: 2, label: "DAYS DEDUCTED" },
    { rowSpan: 2, label: "MINS DEDUCTED" },
    // { rowSpan: 2, label: "ABS-DAYS" },
    { rowSpan: 2, label: "ABS-MINS" },
    { rowSpan: 2, label: "EARNED" },
    { rowSpan: 2, label: "20%" },
    { rowSpan: 2, label: "GRATUITY PAY" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { rowSpan: 2, label: "TAX(3%)" },
    // { rowSpan: 2, label: "2%" },
    { rowSpan: 2, label: "NET AMOUNT" },
  ];

  const IPInitialJOSubHdrs = [...(payItems === "Last" ? ["DATE"] : [])];

  switch (true) {
    case payrollTypes === "IP" &&
      jobTypeVal !== "Job Order" &&
      (payItems === "Initial" || payItems === "Last"):
      return [IndividualHdrs, IndividualSubHdrs];
    case payrollTypes === "IP" && payItems === "Initial AP":
      return [IndividualAPInitialHdrs, IndividualAPInitialSubHdrs];
    case payrollTypes === "IP" && payItems === "Last AP":
      return [IndividualAPLastHdrs, IndividualAPLastSubHdrs];
    case payrollTypes === "IP" && payItems === "Rata":
      return [IndividualRataHdrs, IndividualRataSubHdrs];
    case payrollTypes === "IP" && payItems === "SalaryDiffBasic":
      return [IPSalaryDiffBasicHdrs, IPSalaryDiffBasicSubHdrs];
    case payrollTypes === "IP" && payItems === "SalaryDiffAdd":
      return [IPSalaryDiffAddHdrs, IPSalaryDiffAddSubHdrs];
    case payrollTypes === "IP" &&
      jobTypeVal === "Job Order" &&
      (payItems === "Initial" || payItems === "Last"):
      return [IPInitialJOHdrs, IPInitialJOSubHdrs];
    default:
      return [[], [], []];
  }
};
